export function WhoWeAreSection() {
  return (
    <section className='max-w-7xl mx-auto py-10 md:py-24 flex flex-col md:flex-row items-start md:gap-15 gap-6'>
      <h2
        className='text-2xl whitespace-nowrap md:text-left md:w-fit 
        w-full text-center md:text-[2.5rem] font-bold text-primary'
      >
        Who we are
      </h2>
      <div className='text-sm text-[#463928] font-normal leading-relaxed space-y-4'>
        <p>
          Clovis Classics was created for people who believe classic cars are more than machines—they’re history you can drive.
        </p>
        <p>
          We bring together serious collectors, passionate enthusiasts, and first-time buyers in one trusted marketplace built around transparency and respect for the cars and the people who care about them.
        </p>
        <p>
          Founded and based in <span className='font-bold'>Clovis, California</span>, Clovis Classics serves buyers and
          sellers across the United States. Our platform focuses exclusively on{' '}
          <span className='font-bold'>pre-1975 classics</span>, offering high-quality listing tools to connect buyers
          and sellers directly.
        </p>
        <p>
          We don’t take commissions, represent vehicles, or act as a broker. 
        </p>
        <p>
          We simply provide a secure, curated space where honest listings meet informed buyers. Every listing on Clovis Classics is reviewed for quality and accuracy, and our community is built around shared values of authenticity, preservation, and appreciation for automotive heritage.
        </p>
        <p>
          Our mission is simple: <span className='font-bold text-primary'>Drive history home.</span>
        </p>
      </div>
    </section>
  );
}
